import React, {useEffect, useState} from 'react';
import {EditIcon, LoadingIcon} from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import Switch from "../form/Switch";
import FormHeader from "../form/Header";
import Popup from "../Popup";
import { useUserContext } from '../../contexts/UserContext';
import StateSelect from "../form/StateSelect";
import CountrySelect from "../form/CountrySelect";
import OfficesSelect from "../form/OfficesSelect";
import ShippingMethodSelect from "../form/ShippingMethodSelect";
import {UpdateShippingAddress} from "../../api/shipping-addresses/updateShippingAddress";
import {useTranslation} from "react-i18next";

const EditShippingAddress = ({shippingAddress, onUpdate, onClose, ...props}) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(shippingAddress.is_active);
    const [name, setName] = useState(shippingAddress.name);
    const [office, setOffice] = useState(shippingAddress.office_id);
    const [firstName, setFirstName] = useState(shippingAddress.first_name);
    const [lastName, setLastName] = useState(shippingAddress.last_name);
    const [address1, setAddress1] = useState(shippingAddress.address1);
    const [address2, setAddress2] = useState(shippingAddress.address2);
    const [postalCode, setPostalCode] = useState(shippingAddress.postal_code);
    const [state, setState] = useState(shippingAddress.state);
    const [city, setCity] = useState(shippingAddress.city);
    const [country, setCountry] = useState(shippingAddress.country_code);
    const [shippingMethod, setShippingMethod] = useState(shippingAddress.shipping_method);
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const { userData } = useUserContext();

    const [error, setError] = useState('');



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSubmitDisabled(true);

        try {
            await UpdateShippingAddress(
                shippingAddress.id,
                status,
                office,
                name,
                firstName,
                lastName,
                userData.company_id,
                address1,
                address2,
                postalCode,
                state,
                city,
                country,
                shippingMethod
            );
            setLoading(false);
            setSubmitDisabled(false);
            onUpdate();
        } catch (err){
            setError(err.message);
            setLoading(false);
            setSubmitDisabled(false);
            console.log("Error fetching data: " + err);
        }
    }


    useEffect(() => {
        if (
            status  !== shippingAddress.is_active
            || office  !== shippingAddress.office_id
            || name  !== shippingAddress.name
            || firstName  !== shippingAddress.first_name
            || lastName  !== shippingAddress.last_name
            || address1  !== shippingAddress.address1
            || address2  !== shippingAddress.address2
            || postalCode  !== shippingAddress.postal_code
            || state  !== shippingAddress.state
            || city  !== shippingAddress.city
            || country  !== shippingAddress.country_code
            || shippingMethod !== shippingAddress.shipping_method)
        {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [status, office, name, firstName, lastName, address1, address2, postalCode, state, city, country, shippingMethod]);

    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>
            <form method="post" onSubmit={handleSubmit}>

                <FormHeader title={t("Edit Shipping Address")} icon={<EditIcon/>}
                            description={t("Update the address details to ensure accurate and timely deliveries.")}></FormHeader>

                <div className="row mb-5 mt-5 align-items-center">
                    <div className="col-xs-6">
                        <Switch title={t("Active")}>
                            <input type="checkbox" name="status" id="status" checked={status} onChange={e => {
                                setStatus(e.target.checked)
                            }}/>
                        </Switch>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Office")}>
                            <OfficesSelect
                                defaultOfficeIds={[office]}
                                onChange={setOffice}
                            />
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Shipping address name")} required>
                            <input type="text" name="name" id="name" maxLength="50" value={name}
                                   placeholder={t("Shipping address name")}
                                   onChange={e => setName(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("First Name")} required>
                            <input type="text" name="first_name" id="first_name" maxLength="30" value={firstName}
                                   placeholder={t("First Name")}
                                   onChange={e => setFirstName(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Last Name")} required>
                            <input type="text" name="last_name" id="last_name" maxLength="30" value={lastName}
                                   placeholder={t("Last Name")}
                                   onChange={e => setLastName(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Address 1")} required>
                            <input type="text" name="adddress1" id="adddress1" maxLength="40" value={address1}
                                   placeholder={t("Address 1")}
                                   onChange={e => setAddress1(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Address 2 (Optional)")}>
                            <input type="text" name="address2" id="address2" maxLength="30" value={address2}
                                   placeholder={t("Address 2")}
                                   onChange={e => setAddress2(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Postal Code")} required>
                            <input type="text" name="postalCode" id="postalCode" maxLength="50" value={postalCode}
                                   placeholder={t("Postal Code")}
                                   onChange={e => setPostalCode(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Province")} required>
                            <StateSelect value={state} onChange={option => setState(option.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("City")} required>
                            <input type="text" name="city" id="city" maxLength="20" value={city}
                                   placeholder={t("City")}
                                   onChange={e => setCity(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Country")} required>
                            <CountrySelect value={country} onChange={option => setCountry(option.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Shipping method")} required>
                            <ShippingMethodSelect value={shippingMethod} onChange={option => setShippingMethod(option.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="text-right">
                    <button className={`btn btn-primary btn-medium ${loading ? 'btn-loading' : ''}`} type="submit"
                            name="submit" disabled={submitDisabled}>
                        {loading ? <LoadingIcon/> : ''}
                        {t("Save")}
                    </button>
                </div>
                {error && <p className="color-error text-center mt-3">{error}</p>}
            </form>
        </Popup>
    );
};

export default EditShippingAddress;